import PropTypes from 'prop-types';

import { withInfo, wrapCreator } from './util';

export const string = withInfo(PropTypes.string, { type: 'string' });
export const bool = withInfo(PropTypes.bool, { type: 'bool' });
export const number = withInfo(PropTypes.number, { type: 'number' });
export const func = withInfo(PropTypes.func, { type: 'func' });
export const array = withInfo(PropTypes.array, { type: 'array' });
export const list = withInfo(PropTypes.array, { type: 'list' });
export const object = withInfo(PropTypes.object, { type: 'object' });
export const symbol = withInfo(PropTypes.symbol, { type: 'symbol' });
export const element = withInfo(PropTypes.element, { type: 'element' });
export const node = withInfo(PropTypes.node, { type: 'node' });
export const any = withInfo(PropTypes.any, { type: 'any' });

export const arrayOf = wrapCreator(PropTypes.arrayOf, { type: 'arrayOf' }, true);
export const exact = wrapCreator(PropTypes.exact, { type: 'exact' });
export const objectOf = wrapCreator(PropTypes.objectOf, { type: 'objectOf' }, true);
export const oneOf = wrapCreator(PropTypes.oneOf, { type: 'oneOf' });
export const oneOfType = wrapCreator(PropTypes.oneOfType, { type: 'oneOfType' }, true);
export const shape = wrapCreator(PropTypes.shape, { type: 'shape' }, true);
export const instanceOf = wrapCreator(PropTypes.instanceOf, { type: 'instanceOf' }, true);

export default {
  any,
  string,
  bool,
  number,
  func,
  array,
  list,
  object,
  symbol,
  element,
  node,

  arrayOf,
  exact,
  instanceOf,
  objectOf,
  oneOf,
  oneOfType,
  shape,
};
